
import Vue from 'vue'
import axios from 'axios';
import store from './store';
import router from './router';

import 'bootstrap/dist/css/bootstrap.min.css';

import VueClipboard from 'vue-clipboard2';

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

import app from './app.vue';

new Vue({
	el: '#app',
	store,
	router,
	render: function(createElement){
		return createElement(app);
	}
})



// WEBPACK FOOTER //
// ./src/main.js